import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";

class Signup1 extends Component {
  constructor() {
    super();
    this.state = {
      fields: {},
      errors: {},
      showPwd: false,
      showCPwd: false,
      invitationId:''
    }
  };
  componentDidMount() {
    const queryString = window.location.search;
    console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    const invitationId = urlParams.get('invitationId');
    this.setState({ invitationId: invitationId })
    console.log(invitationId);
  }
  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });
  }


  submituserRegistrationForm = (e) => {
    e.preventDefault();
    let errors = {};
    let SignUp1Controller = this;
    
    var data = {
      password: SignUp1Controller.state.fields.password,
      id: SignUp1Controller.state.invitationId
    }
    if (this.validateForm(e)) {
      $.ajax({
        url: "/my-jeeva-api/sign-up-newuser",
        type: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': "application/json",
      },
        
        data: JSON.stringify(data),
        success: function (res) {
          if (res.success === true) {
            SignUp1Controller.notifySignedUpSuccess();
            window.location.href = "/my-jeeva/login";


          } else {
            errors["response"] = res.result;
            SignUp1Controller.setState({
              errors: errors
            });
          }
        }
      });
    }
  }
  notifySignedUpSuccess() {
    toast.dismiss();
    toast(<b><img src="./assets/images/done.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Welcome to MY JEEVA ADMIN PORTAL</b>, {
      position: "top-center"
    });
  }

  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

   
    if (!fields["password"]) {
      formIsValid = false;
      errors["password"] = "*Please enter your password";
    }

    if (typeof fields["password"] !== "undefined") {
      if (!fields["password"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
        formIsValid = false;
        errors["password"] = "*Please enter secure and strong password";
      }
    }

    if(fields.password !== fields.cpassword) {
      formIsValid = false;
      errors["cpassword"] = "*Password & Confirm Password doesn't match.";
    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

 

  validatePassword = () => {
    let fields = this.state.fields;
    let errors = {};

    if (!fields["password"]) {
      errors["password"] = "*Please enter your password";
    }

    if (typeof fields["password"] !== "undefined") {
      if (!fields["password"].match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&_]{8,30}/)) {
        errors["password"] = "*Please enter secure and strong password";
      }
    }

    // if (fields["password"] !== fields["confirmpwd"]) {
    //   formIsValid = false;
    //   errors["confirmpwd"] = "*Passwords don't matched";
    // }
    this.setState({
      errors: errors
    });
  }

  showPassword = () => {
    if (this.state.showPwd) {
      this.setState({ showPwd: false });
    } else {
      this.setState({ showPwd: true });
    }
  }

  showConfirmPassword = () => {
    if (this.state.showCPwd) {
      this.setState({ showCPwd: false });
    } else {
      this.setState({ showCPwd: true });
    }
  }

  render() {
    return (
      <div className="wrapper">
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link rel="stylesheet" href="./assets/css/styles.css" />

        <ToastContainer className="Toast-at-center" />

        <form method="post">
          <div className="card-body p-0">
            <div className="row">
              <div className="col-lg-12 p-0">
                <div className="card sign-in-right-tab">
                  <div className="card-body sign-in-page">
                    <div className="col-sm-12">
                      <div className="logoBox mb-2">
                        <img src="./assets/images/jeeva-logo.svg" alt="" />
                        <h5 className="signinTitle">Create an Account</h5>
                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                      </div>
                    </div>
                    <div className="col-9 p-0 mx-auto ">
                      <div className="form-group">
                        <div className="crplan mt-1">Set up your credentials</div><br />

                
                        <div className="input-group mb-3">
                          <input
                            type={this.state.showPwd ? "text" : "password"}
                            className="form-control sign-in-forminput passinput noMar" onBlur={this.validatePassword} name="password"
                            onChange={this.handleChange} placeholder="Create Password *" />
                          <div className="input-group-append">
                            <button className="btn showPassbtn" type="button"
                              onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                          </div>
                          <span className="pNote">Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                          <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.password}</div>
                        </div><br />


                        <div className="input-group mb-3">
                          <input
                            type={this.state.showCPwd ? "text" : "password"}
                            className="form-control sign-in-forminput passinput noMar" onBlur={this.validatePassword} name="cpassword"
                            onChange={this.handleChange} placeholder="Confirm Password *" />
                          <div className="input-group-append">
                            <button className="btn showPassbtn" type="button"
                              onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                          </div>
                          <span className="pNote">Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                          <div className="errorMsg" style={{ color: 'red', marginTop: "-6.5rem" }}>{this.state.errors.cpassword}</div>
                        </div><br />
                      </div>
                      <button type="button" className="btn btn-primary btn-block" onClick={this.submituserRegistrationForm}>Sign Up</button>
                      <div className="input-group mb-3 ">
                        <div className="fpass col-12 p-0">
                          <span style={{ color: '#b7b4c0' }}>Already have an account?</span>
                          <Link to="/login"> login</Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default Signup1;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Signup1.js